// extracted by mini-css-extract-plugin
export default {"icon":"Avatar-module_icon_JxLQx","menu-icon":"Avatar-module_menu-icon_BU2HJ"};